export default __webpack_public_path__ + "static/media/crown.026cad89.webp";